import { render, staticRenderFns } from "./MenuTab.vue?vue&type=template&id=78d25cf3&scoped=true&"
import script from "./MenuTab.vue?vue&type=script&lang=js&"
export * from "./MenuTab.vue?vue&type=script&lang=js&"
import style0 from "./MenuTab.vue?vue&type=style&index=0&id=78d25cf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d25cf3",
  null
  
)

export default component.exports